import React, { useEffect, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { onBlankLayout } from 'store/slices/themeSlice';
import { useDispatch, useSelector } from 'react-redux';
import navigationConfig from 'configs/NavigationConfig';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
////
const getAuthUserFromStorage = () => {
	try {
		return JSON.parse(localStorage.getItem('auth_user'));
	} catch (error) {
		return null;
	}
};

const getPrivilegeSet = (privileges) => {
	if (!Array.isArray(privileges)) {
		return new Set();
	}

	return new Set(
		privileges.filter((privilege) => privilege?.hasAccess).map((privilege) => privilege.id)
	);
};

const filterNavigationByPrivileges = (navItems, privilegeSet) => {
	return navItems
		.map((nav) => {
			const requiredPrivileges = Array.isArray(nav.privileges) ? nav.privileges : [];
			const hasRequiredPrivileges = requiredPrivileges.length > 0;
			const allowed =
				!hasRequiredPrivileges || requiredPrivileges.some((privilege) => privilegeSet.has(privilege));
			const filteredSubmenu = Array.isArray(nav.submenu)
				? filterNavigationByPrivileges(nav.submenu, privilegeSet)
				: [];

			if (nav.submenu?.length) {
				if (filteredSubmenu.length > 0) {
					return { ...nav, submenu: filteredSubmenu };
				}

				return allowed ? { ...nav, submenu: [] } : null;
			}

			return allowed ? nav : null;
		})
		.filter(Boolean);
};

const getFirstPath = (navItems) => {
	for (const nav of navItems) {
		if (nav.submenu?.length) {
			const childPath = getFirstPath(nav.submenu);
			if (childPath) {
				return childPath;
			}
		}
		if (nav.path) {
			return nav.path;
		}
	}
	return null;
};

const AppRoute = ({ component: Component, routeKey, blankLayout, ...props }) => {

	const dispatch = useDispatch()
	const location = useLocation()
	const authUser = useSelector((state) => state.auth.auth_user)
	const storageAuthUser = useMemo(getAuthUserFromStorage, [])
	const userAuth = Object.keys(authUser || {}).length ? authUser : storageAuthUser
	const privilegeSet = useMemo(
		() => getPrivilegeSet(userAuth?.privileges),
		[userAuth?.privileges]
	)
	const hasPrivilegeData = Array.isArray(userAuth?.privileges)
	const filteredNavigation = useMemo(
		() =>
			hasPrivilegeData ? filterNavigationByPrivileges(navigationConfig, privilegeSet) : navigationConfig,
		[hasPrivilegeData, privilegeSet]
	)
	const firstAllowedPath = useMemo(() => getFirstPath(filteredNavigation), [filteredNavigation])
	const shouldRedirect =
		hasPrivilegeData &&
		location.pathname === AUTHENTICATED_ENTRY &&
		firstAllowedPath &&
		firstAllowedPath !== AUTHENTICATED_ENTRY

	useEffect(() => {
		const isBlank = blankLayout ? true : false
		dispatch(onBlankLayout(isBlank))

	}, [blankLayout])
	
	if (shouldRedirect) {
		return <Navigate to={firstAllowedPath} replace />
	}

	return (
		<Component {...props} />
	)
}

export default AppRoute
